export default __webpack_public_path__ + "static/media/owner.b6e040cc.png";